module.exports = __webpack_public_path__ + "img/bus_stop.9dd06ed8.png";